import { useState, useEffect, useRef } from 'react';

/**
 * Loading Component
 *
 * @param messages Array of messages to display while loading.
 * @returns {JSX.Element}
 * @constructor
 */
const Loading = ({ messages }) => {
  const [ message, setMessage ] = useState('');

  const maxIndex = useRef();
  let currMsgIndex = useRef(0);

  /**
   * Init messages.
   */
  useEffect(() => {
    if (messages?.length > 0) {
      maxIndex.current = messages.length - 1;

      setMessage(messages[0]);

      setInterval(() => {
        if (currMsgIndex.current === maxIndex.current) {
          currMsgIndex.current = 0;
        } else {
          currMsgIndex.current++;
        }
        setMessage(messages[currMsgIndex.current]);
      }, 5000);
    }
  }, []);

  return (
    <div className="loading">
      <div className="loading-message">{message}</div>
      <div className="loading-icon">
        <div id="ldsEllipsis" className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default Loading;
